import React, { PropTypes, Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";

import {
  TextInput,
  DayPicker,
  NewSelectInput,
  CheckboxInput,
} from "../../../../../../common/form";

import validationUtils from "../../../../../../../utils/ValidationUtils";
import { BENEFICIARIES_VALIDATION_RULES } from "./beneficiariesValidationRules.js";

class BasicBeneficiaryFields extends Component {
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <fieldset disabled={this.props.disabled}>
          <Field
            id="firstName"
            name="firstName"
            component={TextInput}
            type="text"
            label={<FormattedMessage id="beneficiaries.form.firstName" />}
          />
          <Field
            id="lastName"
            name="lastName"
            component={TextInput}
            type="text"
            label={<FormattedMessage id="beneficiaries.form.lastName" />}
          />
          <Field
            id="percentageSplit"
            name="percentageSplit"
            component={TextInput}
            type="absNumber"
            maxLength="10"
            label={<FormattedMessage id="beneficiaries.form.percentageSplit" />}
          />
          <Field
            id="birthdate"
            name="birthdate"
            component={DayPicker}
            type="text"
            maxLength="25"
            label={<FormattedMessage id="beneficiaries.form.birthdate" />}
          />
          <Field
            id="relationship"
            name="relationship"
            component={TextInput}
            type="text"
            label={<FormattedMessage id="beneficiaries.form.relationship" />}
          />
          <Field
            id="isRevocable"
            name="isRevocable"
            component={NewSelectInput}
            options={[
              { value: false, key: "common.no" },
              { value: true, key: "common.yes" },
            ]}
            type="text"
            label={<FormattedMessage id="beneficiaries.form.revocable" />}
          />
          <Field
            id="isMinor"
            name="isMinor"
            component={CheckboxInput}
            type="checkbox"
            checkbox={{ value: true }}
            label={<FormattedMessage id="beneficiaries.form.isMinor" />}
            normalize={(value) => !!value}
          />
          {this.props.isMinor && (
            <div>
              <Field
                id="fiduciaryFirstName"
                name="fiduciaryFirstName"
                component={TextInput}
                type="text"
                label={
                  <FormattedMessage id="beneficiaries.form.fiduciaryFirstName" />
                }
              />
              <Field
                id="fiduciaryLastName"
                name="fiduciaryLastName"
                component={TextInput}
                type="text"
                label={
                  <FormattedMessage id="beneficiaries.form.fiduciaryLastName" />
                }
              />
              <Field
                id="fiduciaryBirthdate"
                name="fiduciaryBirthdate"
                component={DayPicker}
                type="text"
                label={
                  <FormattedMessage id="beneficiaries.form.fiduciaryBirthdate" />
                }
              />
              <Field
                id="fiduciaryRelationship"
                name="fiduciaryRelationship"
                component={TextInput}
                type="text"
                label={
                  <FormattedMessage id="beneficiaries.form.fiduciaryRelationship" />
                }
              />
            </div>
          )}
        </fieldset>
      </form>
    );
  }
}

BasicBeneficiaryFields.propTypes = {
  disabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
  isMinor: PropTypes.bool,
  scene: PropTypes.string,
};

BasicBeneficiaryFields.defaultProps = {
  disabled: false,
  scene: "",
};

BasicBeneficiaryFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state) {
  const selector = formValueSelector("beneficiary");
  return {
    isMinor: selector(state, "isMinor"),
  };
}

export default connect(mapStateToProps, null, null, { withRef: true })(
  reduxForm({
    form: "beneficiary",
    validate: (values) =>
      validationUtils.validate(values, BENEFICIARIES_VALIDATION_RULES),
  })(BasicBeneficiaryFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/beneficiaries/BasicBeneficiaryFields.js